import * as Yup from "yup";

export const initialValues = {
  legal_first_name: "",
  legal_last_name: "",
  profile_name: "",
  phone_number: "",
  email: "",
  title: "",
  url: "",
  upload_date: "",
  wheel: null,
  segment: null,
  additional_data: "",
  dispute_reason: [],
  flagged_content: null,
  acknowledgment: {
    review: false,
    frivolous: false,
  },
};

// Constants for dispute reasons
export const DISPUTE_REASONS = {
  FAIR_USE: 1,
  MISTAKEN_IDENTITY: 2,
  USER_REPORT_INCORRECT: 3,
  OTHER: 4,
};

export const validationSchema = Yup.object().shape({
  legal_first_name: Yup.string().required("First name is required"),
  legal_last_name: Yup.string().required("Last name is required"),
  profile_name: Yup.string().required("Profile name is required"),
  phone_number: Yup.string().required("Phone number is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  title: Yup.string().required("Title is required"),
  url: Yup.string().required("URL is required"),
  upload_date: Yup.string()
    .required("Upload date is required")
    .test("is-valid-date", "Enter a valid date (YYYY-MM-DD)", function (value) {
      if (!value) return false;

      // Check if it matches YYYY-MM-DD format
      const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateFormatRegex.test(value)) return false;

      // Validate that it's a real date
      const date = new Date(value);
      return !isNaN(date.getTime());
    }),
  wheel: Yup.number()
    .typeError("Wheel must be a number")
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .required("Wheel is required"),
  segment: Yup.number()
    .typeError("Segment must be a number")
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .required("Segment is required"),
  additional_data: Yup.string().required("Explanation is required"),
  dispute_reason: Yup.array()
    .min(1, "At least one dispute reason must be selected")
    .required("At least one dispute reason must be selected"),
  flagged_content: Yup.number().nullable(),
  acknowledgment: Yup.object().shape({
    review: Yup.boolean()
      .oneOf([true], "You must acknowledge this statement")
      .required("You must acknowledge this statement"),
    frivolous: Yup.boolean()
      .oneOf([true], "You must acknowledge this statement")
      .required("You must acknowledge this statement"),
  }),
});
